import { computed, inject, Injectable, signal } from '@angular/core';
import { LicenceModuleStatus, LicensingApiService } from '@backend/api/licensing/licensing-api.service';

export const LICENCE_MODULE_CODES = {
  base: 'base',
  neonatology: 'neonatology',
} as const;

@Injectable({ providedIn: 'root' })
export class LicensingService {
  private api = inject(LicensingApiService);

  private modules$ = signal<LicenceModuleStatus[]>([]);

  readonly neonatologyEnabled$ = computed(() => this.isModuleEnabled(LICENCE_MODULE_CODES.neonatology));

  load(): void {
    this.api.getModules().subscribe({
      next: (modules) => this.modules$.set(modules),
    });
  }

  isModuleAvailable(code: string): boolean {
    return this.modules$().find((m) => m.code === code)?.available ?? false;
  }

  isModuleEnabled(code: string): boolean {
    return this.modules$().find((m) => m.code === code)?.enabled ?? false;
  }

  moduleReason(code: string): string | null {
    return this.modules$().find((m) => m.code === code)?.reason ?? null;
  }
}
